var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLove(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.1754 4.00253C20.9848 2.7112 19.3511 2 17.575 2C16.2473 2 15.0314 2.41975 13.961 3.24748C13.4209 3.66525 12.9315 4.17646 12.5 4.77303C12.0687 4.1766 11.5791 3.66525 11.0388 3.24748C9.96856 2.41975 8.75271 2 7.42504 2C5.64887 2 4.01502 2.7112 2.82441 4.00253C1.64804 5.27876 1 7.02231 1 8.91217C1 10.8573 1.7249 12.6379 3.28118 14.5158C4.6734 16.1957 6.67435 17.9009 8.99151 19.8756C9.78277 20.5499 10.6796 21.3143 11.6109 22.1285C11.8569 22.344 12.1729 22.4628 12.5 22.4626C12.8273 22.4626 13.1431 22.344 13.3888 22.1289C14.32 21.3145 15.2174 20.5498 16.009 19.875C18.3258 17.9007 20.3267 16.1957 21.719 14.5156C23.2753 12.6379 24 10.8573 24 8.91199C24 7.02231 23.352 5.27876 22.1754 4.00253Z",
    fill: "url(#paint0_linear_6126_18484)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6126_18484",
    x1: 12.5,
    y1: 2,
    x2: 12.5,
    y2: 22.4626,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#07B9CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#3969E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7D2AE7"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLove);
export default __webpack_public_path__ + "static/media/love.5862db6f6970891c147519ae1c4fe0ef.svg";
export { ForwardRef as ReactComponent };